import 'normalize-css';
import '@SDCss';
import '@/index.styl';

import '@/publicPath';

import routes from '@/routes';
import rootReducer from '@/redux/reducers';

import '@/vendor';
import render from '@/render';
import { configure } from '@moka-fe/mage-micro-app';
import { setupTheme } from 'sugar-design';
import { DingdingPCThemeConfigs } from '@moka-fe/common.theme-configs.dingding-pc';
import { isDingtalk } from '@/constants/common';

const PROJECT = 'headhunter';

configure({
  apiEnabled: true,
  resourcePool: [...window.MOKA_RETRY?.origins, ...window.MATERIAL_PLATFORM_PUBLIC_PATHS] || [
    location.origin,
  ],
  host: window.MATERIAL_PLATFORM_HOST || '',
  project: PROJECT,
  customFilters: {
    cluster: window._MOKA_ENV_?.CLUSTER,
  },
});

if (isDingtalk) {
  setupTheme(DingdingPCThemeConfigs);
}

render(rootReducer, routes, document.getElementById('headhunter-app'));
